import React from 'react';

import Button, { ButtonGroup } from '@atlaskit/button';

import {
  ContainerStyled,
  TextStyled,
} from './TestCaseRepositoryCoverActions.styled';

type Props = {
  onFilterButtonClick: () => void;
  onUndoButtonClick: () => void;
};

export function TestCaseRepositoryCoverActions({
  onFilterButtonClick,
  onUndoButtonClick,
}: Props): JSX.Element {
  return (
    <ContainerStyled>
      <TextStyled>
        Press &quot;Filter&quot; button to refresh the list of test cases
      </TextStyled>
      <ButtonGroup>
        <Button appearance='primary' onClick={onFilterButtonClick}>
          Filter
        </Button>
        <Button appearance='link' onClick={onUndoButtonClick}>
          Undo the changes
        </Button>
      </ButtonGroup>
    </ContainerStyled>
  );
}
